import { Link } from 'react-router-dom';
import { useAccount } from './useAccount';

/** Compact plan + credits indicator for the sidebar. */
export function UsageMeter() {
  const { data: a } = useAccount();
  if (!a) return null;
  if (a.plan.source === 'admin') return <Link to="/plans" className="usage-meter"><span>Administrator</span><small>Unlimited usage</small></Link>;
  const { usedSession, sessionLimit, usedWeek, weeklyLimit, remaining } = a.usage;
  const pct = sessionLimit ? Math.min(100, (usedSession / sessionLimit) * 100) : 0;
  return (
    <Link to="/plans" className="usage-meter" title="Plans and credits">
      <span>{a.plan.name}{a.plan.until ? ' · given' : ''}</span>
      <div className="usage-meter__bar"><div style={{ width: `${pct}%` }} /></div>
      <small>{remaining !== null ? `${Math.max(0, Math.floor(remaining))} usable now · ${Math.max(0, Math.floor((sessionLimit ?? 0) - usedSession))}/${sessionLimit} (session) · ${Math.max(0, Math.floor((weeklyLimit ?? 0) - usedWeek))}/${weeklyLimit} (week)` : ''}</small>
    </Link>
  );
}
